import { nextTick } from 'vue';

interface IFocusableSelectionSearch {
  focus: () => void;
}

export const focusSelectionSearchOnOpen = async (
  searchHeader: IFocusableSelectionSearch | null,
  isMobile: boolean,
): Promise<void> => {
  if (isMobile) return;

  await nextTick();
  searchHeader?.focus();
};
